// 19.1.2.11 Object.isExtensible(O)
var isObject = require('./_is-object');

require('./_object-sap')('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/es6.object.is-extensible.js
 ** module id = 740
 ** module chunks = 0
 **/